import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { I18n } from '../../../base/package/services/package/i18n/i18n.de';
import styles from './view-all-games-button.css?inline';

const CName = 'incentive-view-all-games-button';

@customElement(CName)
export class IncentiveViewAllGamesButton extends LitElement {
  static readonly styles = unsafeCSS(styles);

  render() {
    return html`
      <div class="view-all-games-button">
        ${window.$app.$t.get(I18n.base.viewAll)}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: IncentiveViewAllGamesButton;
  }
}
